'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('emaileditor', {
        url: '/emaileditor',
        template: '<emaileditor></emaileditor>'
    });
}



// WEBPACK FOOTER //
// ./client/app/emaileditor/emaileditor.routes.js